import { z } from 'zod';
/** Gateway families that use a per-OEM adapter Greengrass component + thing group. */
export const GatewayAdapterKindSchema = z.enum(['efem', 'location']);
export const GatewayAdapterKeySchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9][a-z0-9._-]*$/)
    .transform((s) => s.toLowerCase());
export const GATEWAY_ADAPTER_KIND_META = {
    efem: {
        kind: 'efem',
        deviceCategory: 'efem-gateway',
        dynamoAssignmentAttr: 'efemAdapterAssignment',
        iotAdapterKeyAttr: 'efemAdapterKey',
        iotAssignedAtAttr: 'efemAdapterAssignedAt',
    },
    location: {
        kind: 'location',
        deviceCategory: 'location-gateway',
        dynamoAssignmentAttr: 'locationAdapterAssignment',
        iotAdapterKeyAttr: 'locationAdapterKey',
        iotAssignedAtAttr: 'locationAdapterAssignedAt',
    },
};
export { toThingGroupSuffix, edgeThingGroup, tenantThingGroup, efemCategoryThingGroup, locationCategoryThingGroup, efemUnassignedThingGroup, locationUnassignedThingGroup, efemAdapterThingGroup, locationAdapterThingGroup, adapterThingGroupNameFromSuffix, thingGroupsForGateway, greengrassDeployTargetGroup, isManagedThingGroupName, } from './iot-thing-groups.js';
//# sourceMappingURL=gateway-adapter-common.js.map